import { urls } from '@repo/app-constants';
import { TextLink, Typography } from '@repo/ui';
import { createFileRoute } from '@tanstack/react-router';
import blogs from '~/assets/images/blogs.svg';
import interpretiveGuide from '~/assets/images/interpretive-guide.svg';
import patientHandouts from '~/assets/images/patient-handouts.svg';
import tutorialSample from '~/assets/images/tutorial-sample.svg';
import { ClientOnly } from '~/components/ClientOnly/ClientOnly';
import { KitsSection } from '~/components/KitsTable/KitsSection';
import styles from './portal.module.css';

const Portal = () => {
  return (
    <div className='flex flex-column gap-2 flex-grow-1'>
      <div className={styles.mainContent}>
        <ClientOnly>
          <KitsSection />
        </ClientOnly>
      </div>
      <div className='flex flex-column gap-3'>
        <Typography variant='heading-l'>Resources</Typography>
        <div className={styles.resourceGrid}>
          <ResourceCard
            title='The Interpretive Guide'
            image={interpretiveGuide}
            link={urls.PRACTITIONER_RESOURCE_LINKS.INTERPRETIVE_GUIDE}
            linkText='Read guide'
          />
          <ResourceCard
            title='Patient handouts'
            image={patientHandouts}
            link={urls.PRACTITIONER_RESOURCE_LINKS.PATIENT_HANDOUTS}
            linkText='View handouts'
          />
          <ResourceCard
            title='Blogs & Case Studies'
            image={blogs}
            link={urls.PRACTITIONER_RESOURCE_LINKS.BLOG}
            linkText='Read'
          />
          <ResourceCard
            title='Walkthrough tutorials'
            image={tutorialSample}
            link={urls.PRACTITIONER_RESOURCE_LINKS.YOUTUBE}
            linkText='Visit our YouTube'
          />
        </div>
      </div>
    </div>
  );
};

const ResourceCard = ({
  title,
  image,
  link,
  linkText,
}: {
  title: string;
  image: string;
  link: string;
  linkText: string;
}) => {
  return (
    <div className={styles.resourceCard}>
      <img src={image} alt={`${title}`} loading='lazy' />
      <div className={styles.resourceContent}>
        <Typography variant='heading-m'>{title}</Typography>
        <TextLink
          to={link}
          iconNameRight='chevronForward'
          label={linkText}
          external
        />
      </div>
    </div>
  );
};

export const Route = createFileRoute('/_authed/portal')({
  preload: true,
  component: Portal,
});
